module.exports = __webpack_public_path__ + "static/img/h26.bdf3d4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h26.jpg
// module id = XglO
// module chunks = 0